import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import TierBadgeWithTooltip from '../../../../../../TierBadgeWithTooltip';
import { usePrimaryTier } from '../../../../../../Tier/PrimaryTierContext';
import SubscribeButton from '../../../../../../Button/SubscribeButton';
import { formatPrice } from '../../../../../TierProductCardDumb/utils';
import s from './SubscriberThumbPaywall.scss';
var SubscriberThumbPaywall = function (_a) {
    var _b;
    var deviation = _a.deviation, isSmall = _a.isSmall, className = _a.className;
    var tier = usePrimaryTier(deviation);
    if (!tier) {
        return null;
    }
    return (React.createElement("div", { className: classnames(s['root'], isSmall && s['small'], className) },
        React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement(TierBadgeWithTooltip, { isLocked: true, size: 32 })),
        React.createElement("div", { className: s['tier-price'] },
            React.createElement(Trans, { i18nKey: "deviationview.overlay.subscriber.perMonth" },
                React.createElement("span", { className: s['tier-price-amount'] }, { dollarPrice: formatPrice((_b = tier.tier) === null || _b === void 0 ? void 0 : _b.dollarPrice) }),
                "/month")),
        React.createElement(BiLoggerContextProvider, { value: { referral_info: ReferralType.LOCKED_CONTENT } },
            React.createElement(SubscribeButton, { className: s['tier-button'], tier: tier, href: tier.url }))));
};
SubscriberThumbPaywall.displayName = 'SubscriberThumbPaywall';
export default SubscriberThumbPaywall;
//# sourceMappingURL=SubscriberThumbPaywall.js.map